import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CrmLayout } from "@/components/crm/CrmLayout";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Tasks() {
  const nav = useNavigate();
  const { user } = useAuth();
  const [tasks, setTasks] = useState([]);
  const [mine, setMine] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = () => { setLoading(true); api.get("/crm/tasks", { params: { mine } }).then((r) => { setTasks(r.data); setLoading(false); }); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [mine]);

  const toggle = async (t) => { await api.patch(`/crm/tasks/${t.id}`, { done: !t.done }); load(); };
  const open = tasks.filter((t) => !t.done);
  const done = tasks.filter((t) => t.done);

  return (
    <CrmLayout>
      <div className="flex items-center justify-between">
        <div><h1 className="font-display text-2xl font-bold text-slate-900">Tâches & rappels</h1><p className="text-slate-500 text-sm mt-1">{open.length} tâche(s) en cours</p></div>
        <div className="flex gap-2"><Button variant={mine ? "outline" : "default"} size="sm" onClick={() => setMine(false)}>Toutes</Button><Button variant={mine ? "default" : "outline"} size="sm" onClick={() => setMine(true)} data-testid="my-tasks">Les miennes</Button></div>
      </div>
      {loading ? <div className="py-20 text-center"><Loader2 className="animate-spin mx-auto text-blue-600" /></div> : (
        <div className="mt-6 space-y-5">
          <div><h3 className="text-sm font-semibold text-slate-700 mb-2">À faire</h3>
            <div className="space-y-2">{open.map((t) => (
              <Card key={t.id} className="p-4 flex items-center gap-3">
                <input type="checkbox" checked={t.done} onChange={() => toggle(t)} className="w-4 h-4" data-testid={`task-toggle-${t.id}`} />
                <div className="flex-1"><p className="text-sm font-medium text-slate-900">{t.title}</p><p className="text-xs text-slate-400">Échéance : {t.due_date || "—"} · {t.assigned_to}</p></div>
                <Badge variant="secondary" className="text-xs">{t.kind}</Badge>
                <Button size="sm" variant="ghost" onClick={() => nav(`/espace-courtier/prospects/${t.prospect_id}`)}>Voir</Button>
              </Card>))}
              {open.length === 0 && <p className="text-slate-400 text-sm">Aucune tâche en cours.</p>}</div></div>
          {done.length > 0 && <div><h3 className="text-sm font-semibold text-slate-700 mb-2">Terminées</h3>
            <div className="space-y-2">{done.map((t) => (
              <Card key={t.id} className="p-4 flex items-center gap-3 opacity-60">
                <input type="checkbox" checked readOnly className="w-4 h-4" onClick={() => toggle(t)} />
                <p className="text-sm line-through text-slate-500 flex-1">{t.title}</p></Card>))}</div></div>}
        </div>)}
    </CrmLayout>
  );
}
